import defaultObj from "../Wiedergabeverlauf.json";
import db from "../utils/indexedDb";

export const getJsonObj = async () => {
  const jsonObjRaw = await db.jsonStorage.get(1);
  const obj = jsonObjRaw?.jsonObj;

  return obj;
};

export const countVideoPerDay = (json = defaultObj) => {
  let jsonObj = json;

  let results = {},
    arrayOfObjects = [],
    i,
    date;

  for (i = 0; i < jsonObj.length; i++) {
    // map only over videos that still exists,
    // so data matches with other charts
    if (json[i].subtitles) {
      // get the date
      let dateFormat = new Date(jsonObj[i].time);
      date = [
        dateFormat.getFullYear(),
        // make sure the date is always two digits
        ("0" + (dateFormat.getMonth() + 1)).slice(-2),
        ("0" + dateFormat.getDate()).slice(-2),
      ].join("-");
      results[date] = results[date] || 0;
      results[date]++;
    }
  }
  // convert to array of object
  for (i in results) {
    if (results.hasOwnProperty(i)) {
      arrayOfObjects.push({ date: i, count: results[i] });
    }
  }

  const mapDayToMonth = arrayOfObjects.map((x) => ({
    ...x,
    date: `${new Date(x.date).getFullYear()}-${new Date(x.date).getMonth()}`,
  }));

  const sumPerMonth = mapDayToMonth.reduce((acc, cur) => {
    acc[cur.date] = acc[cur.date] + cur.count || cur.count;
    return acc;
  }, {});

  const sumPerYear = mapDayToMonth.reduce((acc, cur) => {
    acc[cur.date.split("-")[0]] = acc[cur.date.split("-")[0]] + cur.count || cur.count;
    return acc;
  }, {});

  // https://stackoverflow.com/a/40655233/9219638
  // returns an array with all missing dates
  const missingDates = [...arrayOfObjects]
    .sort(function (a, b) {
      return Date.parse(a.date) - Date.parse(b.date);
    })
    .reduce(
      (function (hash) {
        return function (p, c) {
          var missingDaysNo = (Date.parse(c.date) - hash.prev) / (1000 * 3600 * 24);
          if (hash.prev && missingDaysNo > 1) {
            for (var i = 1; i < missingDaysNo; i++)
              p.push(new Date(hash.prev + i * (1000 * 3600 * 24)));
          }
          hash.prev = Date.parse(c.date);
          return p;
        };
      })(Object.create(null)),
      []
    );

  const getAverageVideos = (arr, format) => {
    const getDaysInMonth = function (month, year) {
      return new Date(year, month + 1, 0).getDate();
    };

    if (format === "YYYY-MM") {
      const month = arr[0].split("-")[1];
      const year = arr[0].split("-")[0];
      const videoCount = arr[1];
      const averageVieos = videoCount / getDaysInMonth(month, year);
      const rounded = Math.round(averageVieos * 10) / 10;
      return rounded;
    } else if (format === "YYYY") {
      const averageVieos = arr[1] / 365.25;
      const rounded = Math.round(averageVieos * 10) / 10;
      return rounded;
    }
  };

  // The Array format is: [date, videoCount, averagePerDay]
  // ["2016", 4769, 13.6]
  const maxYearArr = Object.entries(sumPerYear).reduce((a, b) => (a[1] > b[1] ? a : b));
  maxYearArr.push(getAverageVideos(maxYearArr, "YYYY"));

  const minYearArr = Object.entries(sumPerYear).reduce((a, b) => (a[1] < b[1] ? a : b));
  minYearArr.push(getAverageVideos(minYearArr, "YYYY"));

  // ["January - 2015", 744, 24.5]
  const maxMonthArr = Object.entries(sumPerMonth).reduce((a, b) => (a[1] > b[1] ? a : b));
  maxMonthArr.push(getAverageVideos(maxMonthArr, "YYYY-MM"));
  maxMonthArr[0] = getReadableDate(maxMonthArr[0], "YYYY-MM");

  const minMonthArr = Object.entries(sumPerMonth).reduce((a, b) => (a[1] < b[1] ? a : b));
  minMonthArr.push(getAverageVideos(minMonthArr, "YYYY-MM"));
  minMonthArr[0] = getReadableDate(minMonthArr[0], "YYYY-MM");

  // {date: "2017-02-19", count: 64}
  const maxDayObj = arrayOfObjects.reduce((a, b) => (a.count > b.count ? a : b));
  // ["Sun Feb 19 2017", 64]
  const maxDayArr = [getReadableDate(maxDayObj.date, "YYYY-MM-dd"), maxDayObj.count];

  // min-Day besides (possibly) 0
  const minDayObj = arrayOfObjects.reduce((a, b) => (a.count < b.count ? a : b));

  // ["Sun Feb 19 2017", 64]
  const minDayArr = [getReadableDate(minDayObj.date, "YYYY-MM-dd"), minDayObj.count];

  return {
    // data for amcharts need's to go from past to recent date
    arrOfObj: arrayOfObjects.reverse(),
    maxYearArr,
    minYearArr,
    maxMonthArr,
    minMonthArr,
    maxDayArr,
    minDayArr,
    missingDates,
  };
};

function getReadableDate(date, format) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  switch (format) {
    case "YYYY-MM":
      return `${months[date.split("-")[1]]} - ${date.split("-")[0]}`;

    case "YYYY-MM-dd":
      return new Date(date).toDateString();
    default:
      return date;
  }
}

export const getTotalVideosPerYear = (data) => {
  let totalVideosPerYear = {};
  Object.entries(data).forEach((entry) => {
    const year = entry[0];
    const channelArr = entry[1];

    channelArr.forEach((channel) => {
      if (!totalVideosPerYear[year]) {
        totalVideosPerYear = { ...totalVideosPerYear, [year]: channel.count };
      } else {
        totalVideosPerYear[year] = totalVideosPerYear[year] + channel.count;
      }
    });
  });

  return totalVideosPerYear;
};

// {Gronkh: 1979, PewDiePie: 1020, Blah: 1293}
export const getCountsPerChannel = (json = defaultObj) => {
  let jsonObj = json;
  let formatted = {};

  jsonObj.forEach(function (video) {
    if (video.subtitles) {
      const channelName = video.subtitles[0].name;
      formatted[channelName] = (formatted[channelName] || 0) + 1;
    }
  });

  return formatted;
};

export const getWordCloudData = (jsonObj) => {
  let data = [];
  let countsPerChannel = getCountsPerChannel(jsonObj);
  // Sort Channels by count
  const sorted = Object.fromEntries(Object.entries(countsPerChannel).sort((a, b) => b[1] - a[1]));

  const sumTotal = Object.values(sorted).reduce((a, b) => a + (b || 0), 0);

  Object.keys(sorted).forEach((key) => {
    data.push({ tag: key, weight: sorted[key] });
  });

  return { data, sumTotal };
};

export const getTreeMapData = (jsonObj) => {
  let data = [];
  let countsPerChannel = getCountsPerChannel(jsonObj);

  const sorted = Object.fromEntries(Object.entries(countsPerChannel).sort((a, b) => b[1] - a[1]));

  Object.keys(sorted)
    .slice(0, 200)
    .forEach((channelName) => {
      data.push({ tag: channelName, weight: sorted[channelName] });
    });

  return data;
};

// ToDo: Pretty slow, need some performance improvements
export const getDataPerYear = (jsonObj) => {
  // has every channel and it's count in the year
  let data = {};
  let allChannels = [];

  // Puts out the count for every channel in a year
  // But doesn't accumulate over the years
  jsonObj.forEach((video) => {
    let year = new Date(video.time).getFullYear();
    if (!data[year]) {
      data[year] = [];
    }

    if (video.subtitles) {
      const objIndex = data[year].findIndex((obj) => obj.channel === video.subtitles[0].name);

      // Channel is not yet in data obj
      if (objIndex === -1) {
        allChannels.push({ channel: video.subtitles[0].name, count: 0 });
        data[year].push({ channel: video.subtitles[0].name, count: 1 });
      } else {
        // Increment Channel Count if already inside data-obj
        data[year][objIndex].count = data[year][objIndex].count + 1;
      }
    }
  });

  return [data, allChannels];
};

function merge(arr1, arr2, accValues = true) {
  // Merge the arrays, and set up an output array.
  const merged = [...arr1, ...arr2];
  const out = [];

  // Loop over the merged array
  for (let obj of merged) {
    // Destructure the object in the current iteration to get
    // its channel and count values
    const { channel, count } = obj;

    // Find the object in out that has the same channel
    const found = out.find((obj) => obj.channel === channel);

    if (accValues) {
      // If an object is found add this object's count to it...
      if (found) {
        found.count += count;

        // ...otherwise push a copy of the object to out
      } else {
        out.push({ ...obj });
      }
    } else {
      if (found) {
        found.count = count;
      } else {
        out.push({ ...obj });
      }
    }
  }

  return out;
}

function mergeArr(arr1, arr2) {
  const result = Object.values(
    [...arr1, ...arr2].reduce((acc, { channel, count }) => {
      acc[channel] = { channel, count: (acc[channel] ? acc[channel].count : 0) + count };
      return acc;
    }, {})
  );

  return result;
}

export const getBarChartRaceData = (jsonObjPara = defaultObj) => {
  const jsonObj = jsonObjPara;

  const [data, allChannels] = getDataPerYear(jsonObj);

  const totalVideosPerYear = getTotalVideosPerYear(data);

  const allChannelsPerYear = data;
  const firstYear = Object.keys(data)[0];
  const lastYear = Object.keys(data)[Object.keys(data).length - 1];

  let accObj = {};
  let tmpVideoArr = [];
  let tmpVideoArr2 = [];

  // accumulate the years and save them in accObj
  Object.entries(data).forEach((entry) => {
    const year = entry[0];
    const videoArr = entry[1];

    // if it's the first year
    if (!data[year - 1]) {
      // append data as is, to th emain obj
      accObj = { [year]: mergeArr(allChannels, data[year]) };

      // save the data in order to merge it with next year
      tmpVideoArr.push(videoArr);
      // save first year
      // firstYear = year;
    } else if (data[year - 1]) {
      // make sure all the channels are inside the year
      tmpVideoArr2 = mergeArr(allChannels, tmpVideoArr);

      // merge all the previous years
      tmpVideoArr = mergeArr(tmpVideoArr2, data[year - 1]);

      // merge previous data with current year
      let tmpObj = mergeArr(tmpVideoArr, data[year]);

      // append year-data to the main obj
      accObj = { ...accObj, [year]: [...tmpObj] };
    }
  });

  let topTwentyPerYearAcc = {};
  let alltop20withCount0 = [];
  let allTopTwenty = {};

  // Iterate over every year in order to filter out the top 20
  // { 2014: [{channel: Gronkh, count: 1292}, {channel: Blubb, count: 0}]}
  for (const [year, videoArr] of Object.entries(accObj)) {
    videoArr.sort((a, b) => b.count - a.count);
    const top20 = videoArr.slice(0, 20);

    // top20.forEach caused a warning
    // make a obj with all top 20 channels and count: 0
    for (let i = 0; i < top20.length; i++) {
      alltop20withCount0.push({ channel: top20[i].channel, count: 0 });
    }

    topTwentyPerYearAcc = { ...topTwentyPerYearAcc, [year]: top20 };
  }

  // make a obj where every years always has all top 20s
  for (const [year, videoArr] of Object.entries(topTwentyPerYearAcc)) {
    // only merge channel names, not counts
    alltop20withCount0 = merge(alltop20withCount0, videoArr, false);
    // push to obj
    allTopTwenty = { ...allTopTwenty, [year]: alltop20withCount0 };
  }

  return {
    allTopTwenty,
    firstYear,
    lastYear,
    data,
    allChannels,
    allChannelsPerYear,
    totalVideosPerYear,
  };
};
